export default class Defer {
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    resolve(value) {
        this.resolve(value);
    }

    reject(reason) {
        this.reject(reason);
    }
}
